module.exports = __webpack_public_path__ + "img/img11.6b5a43e6.svg";